
    export default {
        name: "HappyKidsProductCard",
        props: {
            data: {
                type: Object,
                default: () => ({})
            },
            dataId: {
              type: String,
              default: '',
            }
        },
        computed: {
          insurerImg() {
              return this.data?.Logo;
          },
          ctaLink() {
              return this.data?.ButtonLink;
          },
          features() {
              const item = this.data;
              return [item?.Feature1, item?.Feature2, item?.Feature3, item?.Feature4];
          },
          promo_transData() {
            if(!this?.data?.insurance_company?.insurance_company_translations[0]?.code) {
                console.error('insurer code not found');
                this.$sentry.captureMessage('insurer code not found', 'warning');
            }
            return {
              PromotionCategory: this.data?.promo_trans?.PromotionCategory,
              PromotionTitle: this.data?.promo_trans?.PromotionTitle,
              CTAButtonLink: this.data?.promo_trans?.CTAButtonLink,
              CTAButtonText: this.data?.promo_trans?.CTAButtonText,
              Features: this.data?.promo_trans?.Features,
              RelatedDocuments: this.data?.promo_trans?.RelatedDocuments,
              disclaimer: this.data?.promo_trans?.disclaimer,
              insurerCode: this?.data?.insurance_company?.insurance_company_translations[0]?.code,
              insurerName: this?.data?.insurance_company?.insurance_company_translations[0]?.name,
              productName: this.data?.Name,
              // promotionId: 'product_promotion?.id',
              scenarioId: 'scenarioId',
              lastCall: 'promotion_last_call',
              PromoTooltipPopupCTA: this?.data?.PromoTooltipPopupCTA,
              modalId: this.dataId,
            }
          },
          promoTooltipWidgetData() {
            return{
              Theme: 'Promotion_Tag',
              Icon: {
                url: require('~/assets/images/family/icon/price-tag.svg'),
              },
              Title: this.data?.PromotionText,
              Content: [{ Text: this.data?.promo_trans?.PromotionTitle }]
            }
          },
        },
        methods: {
          openPopUp(popupId) {
            this.$bvModal.show(popupId);
            // this.handleEventTracking()
          },
        },
    }
